var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { initialState } from './initialState';
import { ACTION_BULK_EXPORT as actionTypes } from '../utils/constants';
import { ingestData } from '../services/cimbaIngestion';
export default function (state, action) {
  if (state === void 0) {
    state = initialState.bulkExport;
  }

  switch (action.type) {
    case actionTypes.TOGGLE_IS_EXPORTED:
      {
        return __assign(__assign({}, state), {
          isExported: action.payload
        });
      }

    case actionTypes.TOGGLE_CUSTOM_BULK_EXPORT_MODAL:
      {
        return __assign(__assign({}, state), {
          showCustomBulkExportModal: action.payload
        });
      }

    case actionTypes.TOGGLE_CUSTOM_UPLOAD_MODAL:
      {
        return __assign(__assign({}, state), {
          showCustomUploadModal: action.payload
        });
      }

    case actionTypes.CHANGE_EXPORT_TYPE:
      {
        return __assign(__assign({}, state), {
          value: action.payload
        });
      }

    case actionTypes.SUBMIT_EXPORT_TYPE:
      {
        var value = action.payload;

        if (value === 'bulkExport') {
          return __assign(__assign({}, state), {
            showCustomBulkExportModal: true
          });
        }

        if (value === 'customUpload') {
          return __assign(__assign({}, state), {
            showCustomUploadModal: true
          });
        }

        ingestData({
          feature: 'DisplayedGrid'
        });
        return __assign(__assign({}, state), {
          value: value
        });
      }

    case actionTypes.HANDLE_SEARCH_JOBS_CHANGE:
      {
        var search_1 = action.payload;
        var originalTasksList = state.originalTasksList;

        if (search_1) {
          var filteredTasksList = originalTasksList.filter(function (row) {
            var searchString = search_1.toLowerCase();

            if (row.sku.toLowerCase().includes(searchString) || row.dateSubmitted.toLowerCase().includes(searchString) || row.status.toLowerCase().includes(searchString)) {
              return true;
            }

            return false;
          });
          return __assign(__assign({}, state), {
            tasksList: filteredTasksList,
            searchJobsString: search_1
          });
        }

        return __assign(__assign({}, state), {
          searchJobsString: search_1,
          tasksList: originalTasksList
        });
      }

    case actionTypes.TOGGLE_TASKS_MODAL:
      {
        return __assign(__assign({}, state), {
          showTasksModal: action.payload
        });
      }

    case actionTypes.SET_TASKS_INFO:
      {
        var tasksList = action.payload ? action.payload : [];

        if (tasksList && tasksList.length > 0) {
          tasksList = tasksList.filter(function (task) {
            return task.visible !== false;
          }).filter(function (task) {
            return !task.visible;
          }).map(function (task) {
            var newTask = task;
            newTask.dateSubmitted = new Date(task.dateSubmitted).toLocaleString();
            newTask.status = task.status || 'Error';
            return newTask;
          });
        }

        return __assign(__assign({}, state), {
          tasksList: tasksList,
          originalTasksList: tasksList,
          loadingJobsData: false
        });
      }

    case actionTypes.DELETE_JOB:
      {
        var jobId_1 = action.payload;
        var tasksList = state.tasksList,
            originalTasksList = state.originalTasksList;
        var newTasksList = tasksList.filter(function (_a) {
          var id = _a.id;
          return id !== jobId_1;
        });
        var newOriginalTasksList = originalTasksList.filter(function (_a) {
          var id = _a.id;
          return id !== jobId_1;
        });
        return __assign(__assign({}, state), {
          tasksList: newTasksList,
          originalTasksList: newOriginalTasksList,
          jobDeletedStatus: 'success'
        });
      }

    case actionTypes.DELETE_JOB_SET_STATUS:
      {
        return __assign(__assign({}, state), {
          jobDeletedStatus: action.payload
        });
      }

    default:
      return state;
  }
}